import {
  useGetCurrentExtensionRound,
  useGetExtensionPrice,
  useGetTotalCommitment,
} from '@queries/extensions';

export default function useGetExtensionInfo() {
  const { data: extensionPrice, isLoading: isLoadingPrice } =
    useGetExtensionPrice();
  const { data: commitment, isLoading: isLoadingCommitment } =
    useGetTotalCommitment();
  const { data: currentRound, isLoading: isLoadingCurrentRound } =
    useGetCurrentExtensionRound();

  const totalPrice = extensionPrice?.price;
  const currentCommitment = commitment?.total;
  let leftToCommit;
  if (totalPrice !== undefined && currentCommitment !== undefined)
    leftToCommit = totalPrice - currentCommitment;

  return {
    isExtensionOpen: Boolean(currentRound && totalPrice !== currentCommitment),
    isLoading: isLoadingPrice || isLoadingCommitment || isLoadingCurrentRound,
    hasExtensionExisted: Boolean(extensionPrice),
    totalPrice,
    currentCommitment,
    leftToCommit,
  };
}
